exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kWOFGduxyMBt5cvpvdPfK{width:95%}html[dir] .kWOFGduxyMBt5cvpvdPfK{padding-top:30px}", ""]);

// exports
exports.locals = {
	"listView": "kWOFGduxyMBt5cvpvdPfK"
};